// firebaseHelper.js
import { messaging, deleteToken } from "../../firebase";
import { api } from "@api";

export const unsubscribeFirebase = async () => {
  try {
    const token = localStorage.getItem("token");
    const adminData = localStorage.getItem("admin");
    const admin = adminData ? JSON.parse(adminData) : null;

    if (token && admin) {
      await api.firebaseUnsub({
        token,
        store_id: admin.store_id,
        lang: "en", // or dynamic from i18n if needed
      });

      await deleteToken(messaging);

      localStorage.removeItem("firebaseToken");

      console.log("🔴 Firebase unsubscribed successfully");
    }
  } catch (error) {
    console.error("Firebase unsubscribe error:", error);
  }
};